<script>
  import { industryTypes } from '@/lib/consts'
  import TextMixin from '@/components/report/mixins/TextMixin'

  export default {
    mixins: [ TextMixin ],
    props: {
      indOverride: String,
      tag: { type: String, default () { return 'p' } }
    },
    render ( createElement ) {
      return createElement(
        this.tag,
        {
          'class': [ this.data.class ],
          style: { color: this.color },
          domProps: { innerHTML: this.txt }
        }
      )
    },
    computed: {
      color () {
        return typeof this.data.color === 'undefined'
          ? ''
          : this.data.color.match( /(?:accent|mainColor)/ )
            ? this[ this.data.color ]
            : this.data.color
      },
      txt () {
        let target = '<span class="industry-word"></span>'
        return this.data.txt.replace( target, ( match, offset, str ) => {
          let repl = str.charAt( offset + target.length ) === '.'
            ? industryTypes[ this.industry ].shortName.replace( /\.$/, '' )
            : industryTypes[ this.industry ].shortName
          return '<span class="industry-word">' + repl + '  </span>'
        } )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/report/content/TextFragment.vue